import styled from 'styled-components';

export const ButtonReSendEmailStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  button {
    height: 30px;
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    font-family: inherit;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.alert;
    }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkAlert;
      }};
    }
  }
`;
